// extracted by mini-css-extract-plugin
module.exports = {"projects":"projects-module--projects--2ynd9","title":"projects-module--title--LQwKh","cardContainer":"projects-module--cardContainer--2OgcI"};